"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCaptureMunicipalityMutation = exports.useFetchMunicipalityQuery = exports.useLazySearchMunicipalitiesQuery = exports.useSearchMunicipalitiesQuery = exports.municipalityApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.municipalityApi = (0, react_1.createApi)({
    reducerPath: "municipalityApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["municipality"],
    endpoints: function (builder) { return ({
        searchMunicipalities: builder.query({
            query: function (obj) {
                var _a;
                var params = { limit: (_a = obj.limit) !== null && _a !== void 0 ? _a : 25 };
                if (obj.search)
                    params.search = obj.search;
                if (obj.province)
                    params.province = obj.province;
                if (obj.includeUnverified !== undefined)
                    params.includeUnverified = obj.includeUnverified;
                return { url: "/v1/municipality/search", method: "GET", params: params };
            },
            providesTags: ["municipality"],
        }),
        fetchMunicipality: builder.query({
            query: function (_id) { return ({ url: "/v1/municipality/fetch", method: "GET", params: { _id: _id } }); },
            providesTags: ["municipality"],
        }),
        captureMunicipality: builder.mutation({
            query: function (obj) { return ({ url: "/v1/municipality/capture", method: "POST", body: obj }); },
            invalidatesTags: ["municipality"],
        }),
    }); },
});
exports.useSearchMunicipalitiesQuery = exports.municipalityApi.useSearchMunicipalitiesQuery, exports.useLazySearchMunicipalitiesQuery = exports.municipalityApi.useLazySearchMunicipalitiesQuery, exports.useFetchMunicipalityQuery = exports.municipalityApi.useFetchMunicipalityQuery, exports.useCaptureMunicipalityMutation = exports.municipalityApi.useCaptureMunicipalityMutation;
